import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { mixins } from '../../core/styles/theme/default';

const StyledVisuallyHiddenText = styled.span`
  ${mixins.visuallyHidden};
`;

const A11yText = ({ children, ...rest }: A11yTextProps) => {
  return (
    <StyledVisuallyHiddenText {...rest}>{children}</StyledVisuallyHiddenText>
  );
};

export type A11yTextProps = {
  children: ReactNode;
};

export { A11yText };
